import script from "./Home.vue?vue&type=script&lang=ts&setup=true"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true"

import "./Home.vue?vue&type=style&index=0&id=3e2a2214&lang=scss&scoped=true"

import exportComponent from "D:\\桌面\\报价系统\\quotesystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2a2214"]])

export default __exports__